import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getBrandsLeasingList, statusUpdateBrandsLeasing } from "../../Redux/Actions/brandsLeasingActions";
import "./listBrandsLeasing.css";
import { columnsBrandsLeasingList } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListBrandsLeasing = () => {
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [statusType, setStatusType] = useState("");
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);

    const { brandsLeasingList, loading } = useSelector((state) => state.brandsLeasing || {});
    const BrandsLeasingData = brandsLeasingList;
    console.log('datat', brandsLeasingList)

    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
    const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const fetchDetails = useCallback(async (page, pageSize, showLoader = true) => {
        const brandsLeasingData = {
            page,
            limit: pageSize,
            is_deleted: false,
            filter: debouncedSearch,
            ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
            ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
            ...(statusType && { status: statusType }),
        };

        try {
            await dispatch(getBrandsLeasingList(brandsLeasingData));
            if (!showLoader) {
                toast.success("Brands leasing list refreshed");
            }
        } catch {
            if (showLoader) {
                toast.error("Failed to fetch brands leasing list");
            }
        }
    }, [dispatch, debouncedSearch, dateRange, statusType]);

    const handleStatusChange = async (record, action) => {
        let payload = {
            brand_leasing_id: record._id,
            status: action
        };

        try {
            await dispatch(statusUpdateBrandsLeasing(payload));
            // toast.success("Status updated successfully");
            fetchDetails(pagination.current, pagination.pageSize, false);
        } catch (error) {
            toast.error("Failed to update status");
        }
    };

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [fetchDetails, pagination.current, pagination.pageSize]);

    useEffect(() => {
        if (BrandsLeasingData?.total) {
            setPagination((prevData) => ({ ...prevData, total: BrandsLeasingData.total }));
        }
    }, [BrandsLeasingData]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);

        return () => clearTimeout(handler);
    }, [searchQuery]);

    const handleTableChange = (pagination) => {
        setPagination(pagination);
    };

    const handleDateRangeApply = (start, end) => {
        if (start === null && end === null) {
            setDateRange({ start: null, end: null });
        } else {
            setDateRange({ start, end });
        }
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    return (
        <MainLayout>
            <div className="dashboard-container">
                <div className="table_component_all">
                    <ListTopSearch
                        h3heading="Brands Leasing List"
                        setState={setSearchQuery}
                        buttonhead2={canAdd ? "Add Brands Leasing" : null}
                        navigateTo2={canAdd ? "/brands_leasing/add" : null}
                        onCalendarClick={() => setIsDatePopupVisible(true)}
                    >
                        <div
                            style={{
                                position: "static",
                                marginTop: "-70px",
                                marginLeft: "81%",
                                marginBottom: "24px",
                            }}
                        >
                        </div>
                    </ListTopSearch>
                    <div style={{ overflowX: "auto", padding: "0px 60px" }}>
                        <Table
                            dataSource={Array.isArray(BrandsLeasingData?.data) ? BrandsLeasingData.data : []}
                            pagination={pagination}
                            onChange={handleTableChange}
                            loading={loading}
                            columns={columnsBrandsLeasingList(pagination.current, pagination.pageSize, handleStatusChange, canEdit)}
                            scroll={{ x: 1700, y: 500 }}
                            rowClassName={() => "text-center"}
                        />
                    </div>
                </div>
                <DateRangePopup
                    visible={isDatePopupVisible}
                    initialStart={dateRange.start}
                    initialEnd={dateRange.end}
                    onCancel={() => setIsDatePopupVisible(false)}
                    onOk={handleDateRangeApply}
                />
            </div>
        </MainLayout>
    );
};

export default ListBrandsLeasing;